// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__b76nS","fill":"styles_fill__6HX7J","transparent":"styles_transparent__1uDP1","outline":"styles_outline__mARwP"};